import api from './api';

export default {
    async getUsers(token) {
        try {
            const headers = {
                'Content-Type': 'application/json', 
                'Authorization': `Bearer ${token}`
            };
            const response = await api.get(`/users/`, {
                headers,
            });
            return response;
        } catch (error) {
            console.error('Erro ao fazer listagem de usuários:', error);
                throw error;
        }
    },
    async getUserById(id, token) {
        try {
            const headers = {
                'Content-Type': 'application/json', 
                'Authorization': `Bearer ${token}`
            };
            const response = await api.get(`/users/${id}`, {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao fazer listagem do usuário:', error);
                throw error;
        }
    },
    async createUser(token, payload) {
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            };
            const response = await api.post('/users', payload, {
                headers,
            });
            return response;
        } catch (error) {
            console.error('Erro ao criar usuário:', error);
            throw error;
        }
    },
    async editUser(token, id, payload) {
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            };
            const response = await api.put(`/users/${id}`, payload, {
                headers,
            });
            return response;
        } catch (error) {
            console.error('Erro ao editar usuário:', error);
            throw error;
        }
    },
    async getRoles(token) {
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            };
            const response = await api.get(`/roles`, {
                headers,
            });
            return response;
        } catch (error) {
            console.error('Erro ao listar roles:', error);
            throw error;
        }
    },
    async updateUserRole(token, roleId, userId) {
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            };
            const response = await api.put(`/accounts/roles/${roleId}`, { userId, roleId }, {
                headers,
            });
            return response;
        } catch (error) {
            console.error('Erro ao alterar perfil do usuário:', error);
            throw error;
        }
    },
    async activateUser(payload) {
        try {
            const headers = {
                'Content-Type': 'application/json',
            };
            const response = await api.post(`/public/user/activate`, payload, {
                headers,
            });
            return response;
        } catch (error) {
            console.error('Erro ao ativar usuário:', error);
            throw error;
        }
    },   
    async deleteUser(token, id) {
        try {
            const headers = {
                'Content-Type':'application/json',
                'Authorization': `Bearer ${token}`
            };
            const response = await api.delete(`/users/${id}`, {
                headers,
            });
            return response;
        } catch (error) {
            console.error('Erro ao deletar usuário:', error);
            throw error;
        }
    },
    async changePassword(payload) {
        try {
            const headers = {
                'Content-Type': 'application/json',
            };
            const response = await api.put('/users/change_password', payload, {
                headers,
            });
            return response;
        } catch (error) {
            console.error('Erro ao alterar senha:', error);
            throw error;
        }
    },

};

